import React, { useEffect, useState } from 'react';
import { getFirestore, doc, getDoc } from 'firebase/firestore';
import { initializeApp } from 'firebase/app';
import { useNavigate, useParams } from 'react-router-dom';

const firebaseConfig = {
  apiKey: "AIzaSyDJ_lusSO40qPa2pKdvwOOexRPU2p4Vsro",
  authDomain: "tradeahv2.firebaseapp.com",
  projectId: "tradeahv2",
  storageBucket: "tradeahv2.firebasestorage.app",
  messagingSenderId: "398274404066",
  appId: "1:398274404066:web:74be764b202f62b91f08bb"
};

initializeApp(firebaseConfig);
const db = getFirestore();

export default function NewsDetailsPage() {
  const { id } = useParams();
  const [newsItem, setNewsItem] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchNews = async () => {
      if (!id) {
        navigate('/news');
        return;
      }
      
      try {
        const docRef = doc(db, 'news', id);
        const docSnap = await getDoc(docRef);
        
        if (docSnap.exists()) {
          setNewsItem(docSnap.data());
        } else {
          navigate('/news');
        }
      } catch (error) {
        console.error("Error fetching news:", error);
        navigate('/news');
      } finally {
        setLoading(false);
      }
    };
    
    fetchNews();
  }, [id, navigate]);

  if (loading) {
    return (
      <div style={{ 
        padding: '20px', 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center',
        minHeight: '50vh'
      }}>
        <div style={{ 
          display: 'flex', 
          flexDirection: 'column', 
          alignItems: 'center'
        }}>
          <div style={{ 
            width: '40px', 
            height: '40px', 
            border: '4px solid #1e40af', 
            borderTopColor: 'transparent', 
            borderRadius: '50%', 
            animation: 'spin 1s linear infinite' 
          }}></div>
          <div style={{ marginTop: '16px', color: '#1e40af', fontWeight: '500' }}>
            جاري تحميل الخبر...
          </div>
        </div>
      </div>
    );
  }

  if (!newsItem) {
    return (
      <div style={{ padding: '20px', textAlign: 'center' }}>
        <div style={{ fontSize: '48px', marginBottom: '16px', color: '#cbd5e1' }}>📰</div>
        <h2 style={{ color: '#1e40af' }}>الخبر غير موجود</h2>
        <p style={{ color: '#64748b', marginTop: '8px' }}>
          قد يكون تم حذف هذا الخبر أو نقله.
        </p>
        <button 
          onClick={() => navigate('/news')}
          style={{
            marginTop: '20px',
            backgroundColor: '#1e40af',
            color: 'white',
            border: 'none',
            padding: '10px 24px',
            borderRadius: '8px',
            fontWeight: 'bold',
            cursor: 'pointer'
          }}
        >
          العودة لقائمة الأخبار
        </button>
      </div>
    );
  }

  // دالة لتحويل HTML بسيط إلى عناصر React
  const createMarkup = (htmlString) => {
    if (!htmlString) return { __html: newsItem.summary || '' };
    return { __html: htmlString };
  };

  return (
    <div style={{ 
      padding: '20px', 
      direction: 'rtl', 
      fontFamily: 'Segoe UI, Tahoma, Geneva, Verdana, sans-serif',
      maxWidth: '800px',
      margin: '0 auto'
    }}>
      <div style={{ 
        display: 'flex', 
        justifyContent: 'space-between', 
        alignItems: 'center',
        marginBottom: '24px'
      }}>
        <h1 style={{ color: '#1e40af', margin: 0, fontSize: '28px', fontWeight: '800' }}>
          {newsItem.title}
        </h1>
        <button 
          onClick={() => window.history.back()}
          style={{
            backgroundColor: '#1e40af',
            color: 'white',
            border: 'none',
            padding: '8px 16px',
            borderRadius: '6px',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            gap: '6px'
          }}
        >
          ← العودة
        </button>
      </div>

      {/* معلومات الخبر */}
      <div style={{ 
        display: 'flex', 
        gap: '16px',
        marginBottom: '24px',
        flexWrap: 'wrap'
      }}>
        <div style={{ 
          backgroundColor: newsItem.category === 'analysis' ? '#dcfce7' : 
                         newsItem.category === 'market_news' ? '#dbeafe' : '#fef3c7',
          color: newsItem.category === 'analysis' ? '#166534' : 
                  newsItem.category === 'market_news' ? '#1d4ed8' : '#92400e',
          padding: '6px 12px',
          borderRadius: '12px',
          fontSize: '14px',
          fontWeight: 'bold'
        }}>
          {newsItem.category === 'analysis' ? 'تحليل فني' : 
           newsItem.category === 'market_news' ? 'أخبار السوق' : 'شرح تعليمي'}
        </div>
        <div style={{ color: '#64748b', fontSize: '14px' }}>
          الكاتب: <strong>{newsItem.author || 'TradeAH'}</strong>
        </div>
        <div style={{ color: '#64748b', fontSize: '14px' }}>
          التاريخ: <strong>{newsItem.published_at?.toDate?.().toLocaleDateString('ar-EG') || 'غير معروف'}</strong>
        </div>
      </div>

      {/* صورة الخبر */}
      {newsItem.image_url && (
        <div style={{ 
          marginBottom: '24px', 
          borderRadius: '12px',
          overflow: 'hidden',
          boxShadow: '0 4px 6px rgba(0,0,0,0.1)'
        }}>
          <img
            src={newsItem.image_url}
            alt={newsItem.title}
            style={{ 
              width: '100%', 
              height: '400px', 
              objectFit: 'cover' 
            }}
          />
        </div>
      )}

      {/* محتوى الخبر */}
      <div style={{ 
        backgroundColor: 'white', 
        padding: '24px', 
        borderRadius: '16px',
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
        fontSize: '16px',
        lineHeight: '1.8',
        color: '#1e293b'
      }}>
        {newsItem.content ? (
          <div dangerouslySetInnerHTML={createMarkup(newsItem.content)} />
        ) : (
          <p>{newsItem.summary}</p>
        )}
      </div>

      {/* أزرار المشاركة */}
      <div style={{ 
        marginTop: '24px', 
        display: 'flex', 
        justifyContent: 'center',
        gap: '12px'
      }}>
        <button
          onClick={() => window.print()}
          style={{
            backgroundColor: '#f1f5f9',
            color: '#334155',
            border: '1px solid #e2e8f0',
            padding: '8px 16px',
            borderRadius: '8px',
            fontSize: '14px',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            gap: '6px'
          }}
        >
          🖨️ طباعة
        </button>
        <button
          onClick={() => {
            const url = window.location.href;
            navigator.clipboard.writeText(url).then(() => {
              alert('تم نسخ رابط الخبر إلى الحافظة!');
            });
          }}
          style={{
            backgroundColor: '#f1f5f9',
            color: '#334155',
            border: '1px solid #e2e8f0',
            padding: '8px 16px',
            borderRadius: '8px',
            fontSize: '14px',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            gap: '6px'
          }}
        >
          🔗 نسخ الرابط
        </button>
      </div>

      {/* أنماط CSS للتحميل الدوراني */}
      <style>
        {`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}
      </style>
    </div>
  );
}